import React from 'react';
import Paper from '@material-ui/core/Paper';
import { withStyles } from '@material-ui/core/styles';
import Snackbar from "@material-ui/core/Snackbar";
import ScoreTypeForm from './scoreTypeForm';
import ScoreRecordFormTable from './scoreRecordFormTable';
import Avatar from '@material-ui/core/Avatar';
import Chip from '@material-ui/core/Chip';
import Loading from "../loading/loading";

const styles = theme => ({
  root: theme.mixins.gutters({
    paddingTop: 16,
    paddingBottom: 16,
    marginTop: theme.spacing.unit * 3,
  }),
  paper: {
    position: 'absolute',
    width: theme.spacing.unit * 50,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing.unit * 4,
  },
  button: {
    margin: theme.spacing.unit,
  },
  list: {
    maxHeight: 50 * 2,
    overflowY: 'auto'
  },
  chip: {
    margin: theme.spacing.unit,
  },

});

const storeTypes = [
  {
    id: 'oldStores',
    name: 'Εξάμηνη βαθμολογία'
  },
  {
    id: 'newStores',
    name: 'Εισαγωγική βαθμολογία νέων καταστημάτων'
  },
  // {
  //   id: 'newComingStores',
  //   name: 'Εισαγωγική βαθμολογία υφιστάμενων καταστημάτων'
  // },

];

const ScoreRecord =  (props) =>{
  const { classes, scoreTypeFormValue, uploadModalOpen, closeUploadModal, openUploadModal,
    personHasScoredNewStoreForCriterion, getStoreScoreForCriterionAverageValue, postingFileMessage,
    changeScoreRecordState, loading, postScoreRecordMessage, totalStores, fetchingStores,
    fetchingCriteria } = props;

  return (
    <Paper className={classes.root} elevation={4}>
      <Loading displayLoader={fetchingCriteria || fetchingStores}/>
      <div className={'row'}>
        <div className={'col col-lg-5'}>
          <ScoreTypeForm {...props} storeTypes={storeTypes}/>
        </div>
      </div>
      {
        (scoreTypeFormValue && props.scoreRecord.stores.length > 0 ) && (
          <div className={'row mt-3'}>
            <Chip
              avatar={<Avatar>{props.scoreRecord.stores.length}</Avatar>}
              label="Stores"
              className={classes.chip}
              color="primary"
            />
            <div className={'col-12'}>
              <ScoreRecordFormTable {...props} initialValues={props.scoreRecord}/>
            </div>
          </div>
        )
      }
      <Snackbar
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        open={!!postScoreRecordMessage}
        onClose={() => { props.changeScoreRecordState({key: 'message', value: ''}) }}
        ContentProps={{'aria-describedby': 'message-id',}}
        message={<span id="message-id">{postScoreRecordMessage}</span>}
      />
      <Snackbar
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        open={!!postingFileMessage}
        onClose={() => { props.changeScoreRecordState({key: 'postingFileMessage', value: ''}) }}
        ContentProps={{'aria-describedby': 'message-id',}}
        message={<span id="message-id">{postingFileMessage}</span>}
      />
    </Paper>
  )

};

export default withStyles(styles)(ScoreRecord);



// WEBPACK FOOTER //
// ./src/components/scoreRecord/scoreRecord.js